import { useQuery } from "@tanstack/react-query";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
import apiClient from "@/modules/request.module.v2";

const useCountInvestors = (queryOptions) => {
  const companyId = useCompanyIdFromUrl();

  const query = useQuery({
    ...queryOptions,
    queryKey: ["countInvestors", companyId],
    queryFn: () => {
      return apiClient.get("/shares/company/investors/count", {
        headers: {
          "x-company-id": companyId,
        },
      });
    },
  });

  return query;
};

export { useCountInvestors };
